<shared-modal [mobile]="sharedService.screenSize !== 'l'">
  <!-- header -->
  <h2 slot="header">
    @if (flow.uid) {
      Editar fluxo
    } @else {
      Criar fluxo
    }
  </h2>

  <!-- body -->
  <input placeholder="Nome" [(ngModel)]="flow.label" [disabled]="loading" />

  <!-- footer -->
  @if (flow.uid) {
    <button
      class="mr-auto tertiary"
      slot="footer"
      (click)="delete(); analyticsService.logEvent('admin_delete_flow_click')"
      [disabled]="loading"
    >
      Deletar
    </button>
  }
  <button
    slot="footer"
    class="secondary"
    (click)="
      sharedService.closeModal(route);
      analyticsService.logEvent('admin_close_flow_modal')
    "
    [disabled]="loading"
  >
    Cancelar
  </button>
  <button
    slot="footer"
    [disabled]="!flow.label || loading"
    (click)="save(); analyticsService.logEvent('admin_save_flow_click')"
  >
    {{ loading ? 'Salvando...' : 'Confirmar' }}
  </button>
</shared-modal>
